import { GlobalApplicationsPersonalMenuPersonalMenuDtoUserType } from '@ori/global-api-client-react';

export const isOrisalesAvailable = (userType: GlobalApplicationsPersonalMenuPersonalMenuDtoUserType): boolean =>
  userType === GlobalApplicationsPersonalMenuPersonalMenuDtoUserType.Consultant;
